import { boot } from "quasar/wrappers";
import { isUniversalLinkPath, resolveDeepLinkPath } from "src/utils/deepLink";

export default boot(({ app, router }) => {
  document.addEventListener("deviceready", () => {
    if (typeof window.universalLinks !== "undefined") {
      window.universalLinks.subscribe("launchedAppFromLink", (eventData) => {
        if (!eventData || !eventData.path) return;

        if (isUniversalLinkPath(eventData.path))
          router.push({ path: resolveDeepLinkPath(eventData.path) });
      });
    }
  });
});
